import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import axios from "axios";
import ContentLoader from "react-content-loader";
import Table from "react-bootstrap/Table";

import { REST_API } from "./../../../../services/constants";
import authHeader from "../../../../services/auth-header";

export default function ManageUsers() {
  const [data, setData] = useState({ users: null });
  const [accessDenied, setAccessDenied] = useState(false);

  const updateUsers = async () => {
    try {
      const response = await axios({
        method: "GET",
        url: `${REST_API}/api/secure/users/`,
        headers: await authHeader(),
      });
      setAccessDenied(response.status === 403);
      if (response.status === 200) {
        setData({ users: response.data });
      }
    } catch (error) {
      console.error(error.response);
      if (error.response) {
        setAccessDenied(error.response.status === 403);
      }
    }
  };

  useEffect(() => {
    updateUsers();
  }, []);

  return (
    <>
      <br />
      {data === null ||
      data === undefined ||
      data.users === null ||
      data.users === undefined ? (
        <BootstrapCardDataTable style={{ marginBottom: 40, maxWidth: 1000 }} />
      ) : data.users.length === 0 ? (
        !accessDenied ? (
          <Alert variant="info">Es sind keine Benutzerdaten vorhanden.</Alert>
        ) : (
          <Alert variant="warning">
            Du hast nicht die benötigten Berechtigungen. Bitte frage einen
            Administrator.
          </Alert>
        )
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>E-Mail</th>
              <th>Vorname</th>
              <th>Nachname</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {data.users.map((item, index) => (
              <tr key={index}>
                <td>
                  <Link
                    to={"/admin-dashboard/accounts/" + item.id}
                    style={{ fontWeight: "bold" }}
                  >
                    {item.email || item.username}
                  </Link>
                </td>
                <td>{item.firstName}</td>
                <td>{item.lastName}</td>
                <td>
                  <Link
                    to={"/admin-dashboard/accounts/" + item.id}
                    className="btn btn-outline-primary btn-sm"
                  >
                    Details
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
}

const BootstrapCardDataTable = (props) => {
  return (
    <ContentLoader
      viewBox="0 0 1200 400"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      <rect x="27" y="139" rx="4" ry="4" width="20" height="20" />
      <rect x="67" y="140" rx="10" ry="10" width="85" height="19" />
      <rect x="188" y="141" rx="10" ry="10" width="169" height="19" />
      <rect x="402" y="140" rx="10" ry="10" width="85" height="19" />
      <rect x="523" y="141" rx="10" ry="10" width="169" height="19" />
      <rect x="731" y="139" rx="10" ry="10" width="85" height="19" />
      <rect x="852" y="138" rx="10" ry="10" width="85" height="19" />

      <rect x="26" y="196" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="197" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="198" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="197" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="198" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="196" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="195" rx="10" ry="10" width="85" height="19" />

      <rect x="26" y="258" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="259" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="260" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="259" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="260" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="258" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="257" rx="10" ry="10" width="85" height="19" />

      <circle cx="37" cy="97" r="11" />
      <rect x="26" y="23" rx="5" ry="5" width="153" height="30" />
      <circle cx="77" cy="96" r="11" />
    </ContentLoader>
  );
};
